import { type FC, type ReactElement } from "react";
import * as styles from "./styles.css";

type Props = {
  children: ReactElement[] | ReactElement;
};

export const Label: FC<Props> = ({ children }) => <span className={styles.label}>{children}</span>;
